/**
 * FuarAlaniSalonlarPage.jsx — Salonlar (seçili fuar alanının) (backlog #26, 2026-09-15)
 * Route: /Management/FairAreas/:fuarAlaniId/Salonlar
 *
 * Fuar Alanları listesindeki salon ikonunun hedefi. Her salonun FİZİKSEL TAVANI ve
 * İZİN VERİLEN YÜKSEKLİĞİ burada görüntülenir ve düzenlenir — bunlar salonun fuar alanı
 * seviyesindeki varsayılan yükseklikleridir; Fuar Kuralları → Yükseklik Limitleri sekmesi
 * ikisini salt okunur gösterir. Tablo, detay sayfasındakiyle aynı bileşen.
 *
 * Kroki (salon yerleşim planı) ikonu backlog #27 ile gelecek.
 */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Alert } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import FuarAlaniSalonlariCard from "../../../Components/FairAreas/FuarAlaniSalonlariCard";
import { getFuarAlani } from "../../../services/fuarAlaniSalonService";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

export default function FuarAlaniSalonlarPage() {
  const { t } = useTranslation("yonetim");
  const { fuarAlaniId } = useParams();
  const [fuarAlaniName, setFuarAlaniName] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => { document.title = i18n.t("yonetim:fuarAlaniSalonlar.salonlarFds"); }, []);

  useEffect(() => {
    let ignore = false;
    async function run() {
      try {
        const alani = await getFuarAlani(fuarAlaniId);
        if (!ignore) setFuarAlaniName(alani?.fuarAlaniName ?? null);
      } catch (e) {
        if (!ignore) setError(e.status === 404 ? i18n.t("yonetim:fuarAlaniSalonlar.fuarAlaniBulunamadi") : e.message);
      }
    }
    run();
    return () => { ignore = true; };
  }, [fuarAlaniId]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={fuarAlaniName ? t("fuarAlaniSalonlar.salonlar", { fuarAlaniName }) : t("fuarAlaniSalonlar.salonlar2")} pageTitle={t("fuarAlaniSalonlar.fuarAlanlari")} />

        {error && <Alert color="danger">{error}</Alert>}

        <div className="d-flex gap-2 mb-3">
          <Link to="/Management/FairAreas" className="btn btn-light">
            <i className="bx bx-arrow-back me-1" />{t("fuarAlaniSalonlar.fuarAlanlari")}
          </Link>
          {/* Backlog #51 (2026-09-20): href unchanged — :fuarAlaniId now IS the real detail
              page (WAS the edit form); icon/color updated to match. */}
          <Link to={`/Management/FairAreas/${fuarAlaniId}`} className="btn btn-soft-info">
            <i className="bx bx-show me-1" />{t("fuarAlaniSalonlar.fuarAlaniDetayi")}
          </Link>
        </div>

        {!error && (
          <FuarAlaniSalonlariCard
            fuarAlaniId={fuarAlaniId}
            title={fuarAlaniName ? t("fuarAlaniSalonlar.salonlari", { fuarAlaniName }) : t("fuarAlaniSalonlar.salonlar2")}
          />
        )}
      </Container>
    </div>
  );
}
